function addCategoryDeliveryBanner(){
  switch(lang) {
    case 'sk':
      var categories = [
        {
          text: "MATRACE SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'matrac',
          excluded: 'matrace-na-mieru'
        },
        {
          text: "OHRÁDKY SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'ohradk',
          excluded: ''
        },
        {
          text: "TEEPEE STANY SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'teepee',
          excluded: ''
        },
        {
          text: "KOBERCE SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'kober',
          excluded: ''
        },
        {
          text: "BEHÚNE SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'behun',
          excluded: ''
        },
        {
          text: "Zľavnená cena na produkty platí do vypredania zásob.",
          included: 'vypredaj',
          excluded: ''
        }
      ]
      break;
    case 'hu':
      var categories = [
        {
          text: "A RAKTÁRON LÉVŐ MATRACOKAT 24 ÓRÁN BELÜL FELADJUK.",
          included: 'matrac',
          excluded: ''
        },
        {
          text: "A RAKTÁRON LÉVŐ JÁRÓKÁKAT 24 ÓRÁN BELÜL FELADJUK.",
          included: 'jaroka',
          excluded: ''
        },
        {
          text: "A RAKTÁRON LÉVŐ TEEPEE SÁTRAKAT 24 ÓRÁN BELÜL FELADJUK.",
          included: 'teepee',
          excluded: ''
        },
        {
          text: "A RAKTÁRON LÉVŐ SZŐNYEGEKET 24 ÓRÁN BELÜL FELADJUK.",
          included: 'szonyeg',
          excluded: ''
        },
        {
          text: "Az akciós ár a készlet erejéig érvényes a termékekre.",
          included: 'kiarusitas',
          excluded: ''
        }
      ]
      break;
    case 'cs':
      var categories = [
        {
          text: "MATRACE SKLADEM ODEŠLEME DO 24 HODIN.",
          included: 'matrac',
          excluded: 'matrace-na-miru'
        },
        {
          text: "OHRÁDKY SKLADEM ODEŠLEME DO 24 HODIN.",
          included: 'ohradk',
          excluded: ''
        },
        {
          text: "TEEPEE STANY SKLADEM ODEŠLEME DO 24 HODIN.",
          included: 'teepee',
          excluded: ''
        },
        {
          text: "KOBERCE SKLADEM ODEŠLEME DO 24 HODIN.",
          included: 'kober',
          excluded: ''
        },
        {
          text: "BĚHOUNY SKLADEM ODEŠLEME DO 24 HODIN.",
          included: 'behou',
          excluded: ''
        },
        {
          text: "Zlevněná cena na produkty platí do vyprodání zásob.",
          included: 'vyprodej',
          excluded: ''
        }
      ]
      break;
    // TODO WRO: overiť či vieme odosielať do 24 hod a ako dlho bude trvať doručenie
    case 'ro':
      var categories = [
        {
          text: "SALTELE CARE SUNT ÎN STOC EXPEDIEM ÎN 24 DE ORE.",
          included: 'saltele',
          excluded: 'saltele-la-comanda'
        },
        {
          text: "BARIERE DE PAT ÎN STOC EXPEDIEM ÎN 24 DE ORE.",
          included: 'tarcuri',
          excluded: ''
        },
        {
          text: "CORTURI TIP TEEPEE ÎN STOC EXPEDIEM ÎN 24 DE ORE.",
          included: 'teepee',
          excluded: ''
        },
        {
          text: "COVOARE ÎN STOC EXPEDIEM ÎN 24 DE ORE.",
          included: 'covoare',
          excluded: ''
        },
        {
          text: "ALERGĂTORI DE COVOR ÎN STOC EXPEDIEM ÎN 24 DE ORE.",
          included: 'alergatori',
          excluded: ''
        },
        {
          text: "Preț redus la produse este valabil până la epuizarea stocurilor.",
          included: 'vanzari',
          excluded: ''
        }
      ]
      break;
    case 'bg':
      var categories = [
        {
          text: "MATRACE SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'matrac',
          excluded: 'matrace-na-mieru'
        },
        {
          text: "OHRÁDKY SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'ohradk',
          excluded: ''
        },
        {
          text: "TEEPEE STANY SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'teepee',
          excluded: ''
        },
        {
          text: "KOBERCE SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'kober',
          excluded: ''
        },
        {
          text: "BEHÚNE SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'behun',
          excluded: ''
        },
        {
          text: "Zľavnená cena na produkty platí do vypredania zásob.",
          included: 'vypredaj',
          excluded: ''
        }
      ]
      break;
    case 'hr':
      var categories = [
        {
          text: "MADRACE NA SKLADIŠTU ŠALJEMO U ROKU OD 24 SATA.",
          included: 'madrac',
          excluded: 'madraci-po-mjeri'
        },
        {
          text: "OGRADICE NA SKLADIŠTU ŠALJEMO U ROKU OD 24 SATA.",
          included: 'ogradice',
          excluded: ''
        },
        {
          text: "TEEPEE ŠATORE NA SKLADIŠTU ŠALJEMO U ROKU OD 24 SATA.",
          included: 'teepee',
          excluded: ''
        },
        {
          text: "TEPIHE NA SKLADIŠTU ŠALJEMO U ROKU OD 24 SATA.",
          included: 'tepi',
          excluded: ''
        },
        {
          text: "STAZE NA SKLADIŠTU ŠALJEMO U ROKU OD 24 SATA.",
          included: 'staze',
          excluded: ''
        },
        {
          text: "Snižena cijena na proizvode vrijedi do rasprodaje zaliha.",
          included: 'rasprodaj',
          excluded: ''
        }
      ]
      break;
    case 'sl':
      var categories = [
        {
          text: "VZMETNICE NA ZALOGI BODO ODPOSLANE V 24 URAH.",
          included: 'vzmetnic',
          excluded: 'vzmetnice-po-meri'
        },
        {
          text: "OGRAJE NA ZALOGI BODO ODPOSLANE V 24 URAH.",
          included: 'ograja',
          excluded: ''
        },
        {
          text: "ŠOTORI TEEPEE NA ZALOGI BODO ODPOSLANI V 24 URAH.",
          included: 'teepee',
          excluded: ''
        },
        {
          text: "PREPROGE NA ZALOGI BODO ODPOSLANE V 24 URAH.",
          included: 'preproge',
          excluded: ''
        },
        {
          text: "TEKAČI NA ZALOGI BODO ODPOSLANI V 24 URAH.",
          included: 'tekaci',
          excluded: ''
        },
        {
          text: "Znižana cena za izdelke velja do porabe zalog.",
          included: 'razprodaja',
          excluded: ''
        }
      ]
      break;
    case 'uk':
      var categories = [
        {
          text: "MATRACE SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'matrac',
          excluded: 'matrace-na-mieru'
        },
        {
          text: "OHRÁDKY SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'ohradk',
          excluded: ''
        },
        {
          text: "TEEPEE STANY SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'teepee',
          excluded: ''
        },
        {
          text: "KOBERCE SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'kober',
          excluded: ''
        },
        {
          text: "BEHÚNE SKLADOM ODOŠLEME DO 24 HODÍN.",
          included: 'behun',
          excluded: ''
        },
        {
          text: "Zľavnená cena na produkty platí do vypredania zásob.",
          included: 'vypredaj',
          excluded: ''
        }
      ]
      break;
  }

  if( $('.banner-available-category').length ) {
    $('.banner-available-category').addClass('banner-freeshiping-category-shown');
    return;
  }

  var pageType_contains_category = dataLayer[0]['shoptet']['pageType'];
  if( categories && pageType_contains_category.includes('category') ) {
    for (let i = 0; i < categories.length; i++) {
      if( window.location.href.indexOf(categories[i].included) > -1 ) {
        if( !categories[i].excluded || (categories[i].excluded && window.location.href.indexOf(categories[i].excluded) < 0) ) {
          if( !$('.banner-available-category').length ) {
            if (window.innerWidth <= bpLarge) {
              $('body.type-category #category-header').before(`<div class="banner-available-category">`+categories[i].text+`</div>`);
            } else {
              $('body.type-category #category-header').after(`<div class="banner-available-category">`+categories[i].text+`</div>`);
            }
          }
        }
      }
    }
  }
}
